module.exports = __webpack_public_path__ + "static/media/src-design04.ac568cff.png";